(function () {
  'use strict';
  const COPY = {
    fr: {eyebrow:'Dans la plateforme',title:'Explore ton espace membre.',description:'La formation, le forum, tes outils : parcours chaque section à travers des captures réelles de la plateforme actuelle.',hint:'Fais défiler librement pour explorer',caption:'Captures réelles · Ordinateur et téléphone · Thèmes clair et sombre',expand:'Agrandir',close:'Fermer',zoom:'Zoom',fit:'Ajuster',play:'Lire',pause:'Pause',replay:'Revoir',sections:'Sections de la plateforme',capture:'Plateforme Ephore Market actuelle',viewport:'Capture de la plateforme. Fais défiler pour explorer.',dialog:'Capture complète de la plateforme',error:'Cette capture ne peut pas être chargée pour le moment.'},
    en: {eyebrow:'Inside the platform',title:'Explore your member area.',description:'Training, the forum, your tools: explore each section through real captures of the current platform.',hint:'Scroll freely to explore',caption:'Real captures · Computer and phone · Light and dark themes',expand:'Enlarge',close:'Close',zoom:'Zoom',fit:'Fit',play:'Play',pause:'Pause',replay:'Replay',sections:'Platform sections',capture:'Current Ephore Market platform',viewport:'Platform capture. Scroll to explore.',dialog:'Full platform capture',error:'This capture cannot be loaded at the moment.'}
  };
  const ORDER = ['qg','formation','trading','gpt','journal','forum','actus','arene','ambassade'];
  const INTRO_MS = 1700, SCROLL_MS = 24000, BOTTOM_MS = 3000;
  const init = function (root) {
    if (root.dataset.emInitialized) return;
    root.dataset.emInitialized = 'true';
    const get = selector => root.querySelector(selector);
    let media;
    try { media = JSON.parse(get('[data-em-media]').textContent); } catch (_) { return; }
    if (!media || !Array.isArray(media.items) || !media.items.length) return;
    const items = ORDER.map(id => media.items.find(item => item.id === id)).filter(Boolean);
    if (!items.length) return;
    const viewport = get('[data-em-viewport]'), image = get('[data-em-image]');
    const play = get('[data-em-play]'), expand = get('[data-em-expand]');
    const dialog = get('[data-em-dialog]'), dialogImage = get('[data-em-dialog-image]');
    const panel = get('[role="tabpanel"]'), tabs = Array.from(root.querySelectorAll('[data-em-tab]'));
    const progress = get('[data-em-progress]'), status = get('[data-em-status]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, language = root.dataset.initialLanguage === 'en' ? 'en' : 'fr';
    let source = null, variant = '', ready = false, visible = false, completed = false;
    let requestedPlay = !reduced.matches, userPaused = false, frame = 0, lastTime = 0;
    let phase = 'intro', phaseTime = 0, distance = 0, exactPosition = 0, loadToken = 0, dialogOpener = null;
    const current = () => items[index];
    const words = () => COPY[language];
    const getLanguage = () => root.dataset.fixedLanguage ? root.dataset.initialLanguage : (document.documentElement.lang.toLowerCase().startsWith('en') ? 'en' : 'fr');
    const getTheme = () => {
      const html = document.documentElement, normal = html.getAttribute('data-theme'), alternate = html.getAttribute('data-ev-theme');
      if (normal === 'light') return 'light';
      if (normal === 'dark') return 'dark';
      return alternate === 'clair' ? 'light' : 'dark';
    };
    const label = item => item.label && (item.label[language] || item.label.fr) || item.id;
    const updateProgress = () => { progress.style.transform = 'scaleX(' + (distance > 0 ? Math.min(1,viewport.scrollTop / distance) : 0) + ')'; };
    const updateControl = () => {
      play.disabled = !ready;
      expand.disabled = !ready;
      const paused = !requestedPlay || completed;
      get('[data-em-play-label]').textContent = completed ? words().replay : paused ? words().play : words().pause;
      get('[data-em-play-icon]').textContent = completed ? '↻' : paused ? '▶' : 'Ⅱ';
      play.setAttribute('aria-label',get('[data-em-play-label]').textContent + ' · ' + label(current()));
    };
    const stop = () => { if (frame) cancelAnimationFrame(frame); frame = 0; lastTime = 0; };
    const canRun = () => ready && visible && !document.hidden && requestedPlay && !completed && !dialog.open;
    const tick = time => {
      frame = 0;
      if (!canRun()) { lastTime = 0; return; }
      let elapsed = lastTime ? Math.min(80,time-lastTime) : 0;
      lastTime = time;
      // Only visible, active animation time counts toward each section's cycle.
      while (elapsed > 0) {
        const duration = phase === 'intro' ? INTRO_MS : phase === 'scroll' ? SCROLL_MS : BOTTOM_MS;
        const step = Math.min(elapsed,duration-phaseTime);
        phaseTime += step; elapsed -= step;
        if (phase === 'scroll') {
          exactPosition = distance * Math.min(1,phaseTime/SCROLL_MS);
          viewport.scrollTop = exactPosition;
          updateProgress();
        }
        if (phaseTime >= duration) {
          if (phase === 'intro') { phase='scroll'; phaseTime=0; }
          else if (phase === 'scroll') {
            viewport.scrollTop=distance; exactPosition=distance; updateProgress();
            phase='bottom'; phaseTime=0;
            if (reduced.matches) { completed=true; requestedPlay=false; updateControl(); stop(); return; }
          } else {
            if (reduced.matches) { completed=true; requestedPlay=false; updateControl(); stop(); return; }
            select((index+1)%items.length,false);
            return;
          }
        }
      }
      frame = requestAnimationFrame(tick);
    };
    const sync = () => { if (canRun()) { if (!frame) frame = requestAnimationFrame(tick); } else stop(); updateControl(); };
    const pauseForUser = () => { requestedPlay = false; userPaused = true; stop(); updateControl(); };
    const measure = () => {
      distance = Math.max(0,viewport.scrollHeight-viewport.clientHeight);
      if (requestedPlay && phase === 'scroll') viewport.scrollTop=distance*Math.min(1,phaseTime/SCROLL_MS);
      else if (phase === 'bottom') viewport.scrollTop=distance;
      exactPosition = Math.min(distance,viewport.scrollTop);
      updateProgress(); sync();
    };
    const translate = () => {
      root.querySelectorAll('[data-em-copy]').forEach(node => { const key=node.dataset.emCopy; if (words()[key]) node.textContent=words()[key]; });
      get('[role="tablist"]').setAttribute('aria-label',words().sections);
      viewport.setAttribute('aria-label',words().viewport);
      dialog.setAttribute('aria-label',words().dialog);
      tabs.forEach(tab => {
        const item=items.find(item => item.id === tab.dataset.emTab);
        tab.hidden = !item;
        if (item) tab.textContent=label(item);
      });
      get('[data-em-section-name]').textContent = label(current());
      image.alt = words().capture + ' : ' + label(current());
      const privacy=get('[data-em-privacy]');
      if(privacy){privacy.hidden=current().id!=='journal';privacy.textContent=language==='en'?'Account details hidden':'Données de compte masquées';}
      get('[data-em-dialog-title]').textContent=label(current())+' · app.ephore-market.com';
      if (dialog.open) dialogImage.alt=image.alt;
      const zoomed=dialog.dataset.emZoomed==='true';
      get('[data-em-zoom] [data-em-copy]').textContent=zoomed ? words().fit : words().zoom;
      updateControl();
    };
    const load = () => {
      stop(); ready=false; completed=false; phase='intro'; phaseTime=0; exactPosition=0; distance=0;
      viewport.scrollTop=0; progress.style.transform='scaleX(0)'; status.textContent='';
      root.dataset.emLoading='true';
      language=getLanguage()==='en'?'en':'fr'; variant=language+'-'+getTheme();
      source=current().sources && current().sources[variant];
      tabs.forEach(tab => {
        const active=tab.dataset.emTab===current().id;
        tab.setAttribute('aria-selected',String(active)); tab.tabIndex=active?0:-1;
        if (active) panel.setAttribute('aria-labelledby',tab.id);
      });
      translate();
      const token=++loadToken;
      if (!source || !source.url) { root.dataset.emLoading='false'; status.textContent=words().error; return; }
      const loaded = () => {
        if (token!==loadToken) return;
        if (!image.naturalWidth) { failed(); return; }
        ready=true; root.dataset.emLoading='false'; image.alt=words().capture+' : '+label(current());
        viewport.scrollTop=0; exactPosition=0;
        if (dialog.open) { dialogImage.src=source.url; dialogImage.width=source.width; dialogImage.height=source.height; dialogImage.alt=image.alt; get('[data-em-dialog-scroll]').scrollTop=0; }
        measure();
      };
      const failed = () => { if (token!==loadToken) return; ready=false; root.dataset.emLoading='false'; status.textContent=words().error; updateControl(); };
      image.onload=loaded; image.onerror=failed;
      image.width=Number(source.width)||1600; image.height=Number(source.height)||1000;
      image.src=source.url;
      if (image.complete) { if (image.naturalWidth) loaded(); else failed(); }
    };
    const select = (newIndex,focus) => {
      if (newIndex<0||newIndex>=items.length) return;
      index=newIndex;
      if (!userPaused&&!reduced.matches) requestedPlay=true;
      load();
      const tab=tabs.find(tab=>tab.dataset.emTab===current().id);
      if (tab) {
        if (focus) tab.focus({preventScroll:true});
        // Scroll only the horizontal tab strip; never move the surrounding page.
        const list=get('[role="tablist"]'), bounds=list.getBoundingClientRect(), tabBounds=tab.getBoundingClientRect();
        if (tabBounds.left < bounds.left) list.scrollLeft+=tabBounds.left-bounds.left;
        else if (tabBounds.right > bounds.right) list.scrollLeft+=tabBounds.right-bounds.right;
      }
    };
    tabs.forEach(tab => {
      tab.addEventListener('click',()=>select(items.findIndex(item=>item.id===tab.dataset.emTab),false));
      tab.addEventListener('keydown',event=>{
        const keys=['ArrowRight','ArrowLeft','Home','End']; if (!keys.includes(event.key)) return;
        event.preventDefault(); const here=items.findIndex(item=>item.id===tab.dataset.emTab);
        const next=event.key==='Home'?0:event.key==='End'?items.length-1:(here+(event.key==='ArrowRight'?1:-1)+items.length)%items.length;
        select(next,true);
      });
    });
    play.addEventListener('click',()=>{
      if (completed) { completed=false; viewport.scrollTop=0; exactPosition=0; phase='intro'; phaseTime=0; requestedPlay=true; userPaused=false; }
      else {
        requestedPlay=!requestedPlay; userPaused=!requestedPlay;
        if (requestedPlay && Math.abs(viewport.scrollTop-exactPosition)>.5) {
          exactPosition=Math.min(distance,viewport.scrollTop);
          phase='scroll'; phaseTime=distance>0?SCROLL_MS*exactPosition/distance:0;
        }
      }
      sync();
    });
    viewport.addEventListener('wheel',pauseForUser,{passive:true});
    viewport.addEventListener('touchstart',pauseForUser,{passive:true});
    viewport.addEventListener('pointerdown',pauseForUser,{passive:true});
    viewport.addEventListener('keydown',event=>{ if (['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key)) pauseForUser(); });
    viewport.addEventListener('scroll',updateProgress,{passive:true});
    expand.addEventListener('click',()=>{
      if (!ready||!source) return;
      stop(); dialogOpener=expand; dialogImage.src=source.url; dialogImage.width=source.width; dialogImage.height=source.height; dialogImage.alt=image.alt;
      dialog.dataset.emZoomed='false'; get('[data-em-zoom]').setAttribute('aria-pressed','false');
      get('[data-em-zoom] [data-em-copy]').textContent=words().zoom;
      if (typeof dialog.showModal==='function') dialog.showModal(); else { window.open(source.url,'_blank','noopener'); return; }
      get('[data-em-dialog-scroll]').scrollTop=0; get('[data-em-dialog-scroll]').scrollLeft=0; get('[data-em-close]').focus();
    });
    get('[data-em-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{ if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();} });
    dialog.addEventListener('close',()=>{ if(dialogOpener)dialogOpener.focus(); sync(); });
    get('[data-em-zoom]').addEventListener('click',()=>{
      const zoomed=dialog.dataset.emZoomed!=='true'; dialog.dataset.emZoomed=String(zoomed);
      get('[data-em-zoom]').setAttribute('aria-pressed',String(zoomed)); get('[data-em-zoom] [data-em-copy]').textContent=zoomed?words().fit:words().zoom;
    });
    document.addEventListener('visibilitychange',sync);
    const reduceChanged=()=>{ if(reduced.matches)pauseForUser(); };
    if(reduced.addEventListener)reduced.addEventListener('change',reduceChanged);
    const mutation=new MutationObserver(()=>{
      const nextLanguage=getLanguage()==='en'?'en':'fr',nextVariant=nextLanguage+'-'+getTheme();
      if(nextVariant!==variant){if(!userPaused&&!reduced.matches)requestedPlay=true;load();}
    });
    mutation.observe(document.documentElement,{attributes:true,attributeFilter:['lang','data-theme','data-ev-theme']});
    if('ResizeObserver' in window)new ResizeObserver(measure).observe(viewport);
    else window.addEventListener('resize',measure,{passive:true});
    if('IntersectionObserver' in window){new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0.15}).observe(viewport);}
    else visible=true;
    load();
  };
  const mount=()=>document.querySelectorAll('[data-em-platform-preview]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();

